import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import MaterialTable from 'material-table'
import { Remove } from '@material-ui/icons'
import { Loader } from '../../default'
import { dateFormat, maskCurrency } from '../../../class/utils'

function TableFilterList({
    selectedFilter, filteredUsers, loadingFilteredUsers
}) {
    const { t } = useTranslation()

    const [fileName, setFileName] = useState('ResultsForFilterId')

    useEffect(() => {
        if (selectedFilter)
            setFileName('ResultsForFilterId' + selectedFilter.filter_id)
    }, [selectedFilter])

    const prepareColumns = () => {
        return [
            { title: t('panels.filters.list.table.columns.id'), field: 'id', width: '2%', defaultSort: 'asc' },
            { title: t('panels.filters.list.table.columns.company'), field: 'company', width: '10%' },
            { title: t('panels.filters.list.table.columns.name'), field: 'name', width: '15%' },
            { title: t('panels.filters.list.table.columns.email'), field: 'email', width: '10%' },
            { title: t('panels.filters.list.table.columns.phone'), field: 'phone', width: '10%' },
            { title: t('panels.filters.list.table.columns.credits'), field: 'credits', width: '10%' },
            { title: t('panels.filters.list.table.columns.consults'), field: 'consults', width: '5%' },
            { title: t('panels.filters.list.table.columns.cpfs'), field: 'cpfs', width: '5%' },
            { title: t('panels.filters.list.table.columns.cnpjs'), field: 'cnpjs', width: '5%' },
            { title: t('panels.filters.list.table.columns.plan'), field: 'plan', width: '5%' },
            { title: t('panels.filters.list.table.columns.registerDate'), field: 'registerDate', width: '10%' },
        ];
    }

    const prepareData = () => {
        if (!filteredUsers) {
            return []
        }

        return filteredUsers.map(user => {
            return {
                id: user.customer_id,
                company: user.company,
                name: user.first_name + ' ' + user.last_name,
                email: user.email,
                phone: user.phone_1,
                credits: user.overall_sum ? maskCurrency(user.overall_sum) : maskCurrency(0),
                consults: user.overall_count ? user.overall_count : 0,
                cpfs: user.distinct_cpf_count ? user.distinct_cpf_count : 0,
                cnpjs: user.distinct_cnpj_count ? user.distinct_cnpj_count : 0,
                plan: user.plan ? user.plan : <Remove />,
                registerDate: dateFormat(user.created_at),
            }
        })

    }

    return (
        <>
            {
                loadingFilteredUsers
                    ? <Loader />
                    : (
                        <MaterialTable
                            title={t('panels.filters.list.table.title')}
                            columns={prepareColumns()}
                            data={prepareData()}
                            localization={t('materialTableLocale', { returnObjects: true })}
                            options={{
                                pageSize: 10,
                                toolbar: true,
                                grouping: true,
                                exportButton: {
                                    csv: true,
                                    pdf: true
                                },
                                exportFileName: fileName,
                                exportAllData: true
                            }}
                        />
                    )
            }
        </>
    )
}

TableFilterList.propTypes = {
    filteredUsers: PropTypes.array,
}

TableFilterList.defaultProps = {
    filteredUsers: []
}

const mapStateToProps = ({ ReducerFilter }) => ({
    selectedFilter: ReducerFilter.selectedFilter,
    filteredUsers: ReducerFilter.filteredUsers,
    loadingFilteredUsers: ReducerFilter.loadingFilteredUsers
})

export default connect(mapStateToProps)(TableFilterList)